import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useCurrentUser } from "contexts/CurrentUserContext";
import { FeatureFlagProvider } from "frontend/context/FeatureFlagContext";
var FeatureFlagBridge = function (_a) {
    var _b;
    var children = _a.children;
    var currentUser = useCurrentUser();
    return (_jsx(FeatureFlagProvider, { flags: (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.featureFlags) !== null && _b !== void 0 ? _b : null, children: children }));
};
export default FeatureFlagBridge;
